export default {
    props: [
        'name',
        'date',
        'status',
        'type',
        'sales',
        'target',
        'associate',
    ],
}